var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16.3667V14.5C23.3333 14.0049 23.1367 13.5302 22.7866 13.1801C22.4365 12.83 21.9618 12.6333 21.4667 12.6333H2.80002C2.30495 12.6333 1.83015 12.83 1.48008 13.1801C1.13002 13.5302 0.93335 14.0049 0.93335 14.5V25.7C0.93335 26.1951 1.13002 26.6699 1.48008 27.0199C1.83015 27.37 2.30495 27.5667 2.80002 27.5667H21.4667C21.9618 27.5667 22.4365 27.37 22.7866 27.0199C23.1367 26.6699 23.3333 26.1951 23.3333 25.7V23.8333M23.3333 16.3667H15.8667C14.8765 16.3667 13.927 16.76 13.2268 17.4602C12.5267 18.1603 12.1333 19.1099 12.1333 20.1C12.1333 21.0902 12.5267 22.0397 13.2268 22.7399C13.927 23.44 14.8765 23.8333 15.8667 23.8333H23.3333M23.3333 16.3667C24.3235 16.3667 25.2731 16.76 25.9732 17.4602C26.6733 18.1603 27.0667 19.1099 27.0667 20.1C27.0667 21.0902 26.6733 22.0397 25.9732 22.7399C25.2731 23.44 24.3235 23.8333 23.3333 23.8333M6.53335 12.6333V7.03335C6.53335 5.54814 7.12335 4.12376 8.17355 3.07355C9.22376 2.02335 10.6481 1.43335 12.1333 1.43335C13.6186 1.43335 15.0429 2.02335 16.0931 3.07355C17.1434 4.12376 17.7333 5.54814 17.7333 7.03335V12.6333M22.4 20.1H24.2667M18.6667 20.1H20.5333M14.9333 20.1H16.8",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.a0a313c9676669f0e948348d1921e717.svg";
export { ForwardRef as ReactComponent };